import { create } from "zustand";

/**
 * Open/close state for the XAES-AI info+chat modal (HudHeader → XAES-AI
 * button). Lifted out of HudHeader's local state into a global store so
 * the page-side `<XaesAnalyst>` sidebar can subscribe and dismount while
 * the modal is open.
 *
 * Why dismount instead of co-existing? Two mounts with the same
 * `userId` + `workshopId` would each drive the shared chat runtime and
 * risk duplicate stream handlers. Dismounting the sidebar while the
 * modal is open lets one panel own the UI; the live buffer itself lives
 * in `chat-runtime-store`, so closing the modal remounts the sidebar
 * onto the same in-progress session (until New chat or a page refresh).
 */
type XaesAgentModalState = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export const useXaesAgentModal = create<XaesAgentModalState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
